export default __webpack_public_path__ + "0f4f11227e9e009eb5409c958897c8e1.jpg";